import React from "react";
import Login from "../../pages/auth/Login";
import ForgotPassword from "../../pages/auth/forgotpassword/ForgotPassword";
import OtpConfirm from "../../pages/auth/otp/OtpConfirm";
import ResetPassword from "../../pages/auth/reset-password/ResetPassword";


interface routes {
    key: string;
    path: string;
    labelNameEn: string;
    labelNameTh: string;
    component: React.ComponentType;
}


export const authRoute: routes[] = [
    {
        key: "LOGIN_PAGE",
        path: "/login",
        labelNameEn: "Login",
        labelNameTh: "ลงชื่อเข้าใช้",
        component: Login
    },
    {
        key: "FORGOT_PASSWORD",
        path: "/forgot-password",
        labelNameEn: "Forgot-password",
        labelNameTh: "ลืมรหัสผ่าน?",
        component: ForgotPassword
    },
    {
        key: "OTP_CONFIRM",
        path: "/otp-confirm",
        labelNameEn: "Confirm Otp",
        labelNameTh: "ยืนยัน Otp",
        component: OtpConfirm
    },
    {
        key: "RESET_PASSWORD",
        path: "/reset-password",
        labelNameEn: "Reset-password",
        labelNameTh: "เปลี่ยนรหัสผ่าน",
        component: ResetPassword
    },
]